module.exports = __webpack_public_path__ + "static/media/1POLICY39.8b735d10.jpg";